import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as insight360Actions from '../../actions/insight360Actions';
import demoAgeIcon from '../../images/insight360/demo-age-icon.png';
import demoChildrenIcon from '../../images/insight360/demo-children-icon.png';
import demoEducationIcon from '../../images/insight360/demo-education-icon.png';
import demoEmploymentIcon from '../../images/insight360/demo-employment-icon.png';
import demoEthnicityIcon from '../../images/insight360/demo-ethnicity-icon.png';
import demoGenderIcon from '../../images/insight360/demo-gender-icon.png';
import demoIncomeIcon from '../../images/insight360/demo-income-icon.png';
import demoMaritalStatusIcon from '../../images/insight360/demo-marital-status-icon.png';
import demoPoliticalIcon from '../../images/insight360/demo-political-icon.png';
import demoRaceIcon from '../../images/insight360/demo-race-icon.png';
import demoRegionIcon from '../../images/insight360/demo-region-icon.png';
import demoResidenceIcon from '../../images/insight360/demo-residence-icon.png';
import demoOccupationIcon from '../../images/insight360/demo-occupation-icon.png';

const iconComponents = [
  { id: 'demoAgeIcon', demoName: 'Age', selectedIcon: demoAgeIcon },
  {
    id: 'demoChildrenIcon',
    demoName: 'Children in Household',
    selectedIcon: demoChildrenIcon,
  },
  {
    id: 'demoEducationIcon',
    demoName: 'Education',
    selectedIcon: demoEducationIcon,
  },
  {
    id: 'demoEmploymentIcon',
    demoName: 'Employment Status',
    selectedIcon: demoEmploymentIcon,
  },
  {
    id: 'demoEthnicityIcon',
    demoName: 'Ethnicity',
    selectedIcon: demoEthnicityIcon,
  },
  { id: 'demoGenderIcon', demoName: 'Gender', selectedIcon: demoGenderIcon },
  {
    id: 'demoIncomeIcon',
    demoName: 'Household Income',
    selectedIcon: demoIncomeIcon,
  },
  {
    id: 'demoMaritalStatusIcon',
    demoName: 'Marital Status',
    selectedIcon: demoMaritalStatusIcon,
  },
  {
    id: 'demoPoliticalIcon',
    demoName: 'Political Outlook',
    selectedIcon: demoPoliticalIcon,
  },
  { id: 'demoRaceIcon', demoName: 'Race', selectedIcon: demoRaceIcon },
  {
    id: 'demoRegionIcon',
    demoName: 'Census Region',
    selectedIcon: demoRegionIcon,
  },
  {
    id: 'demoResidenceIcon',
    demoName: 'Residence',
    selectedIcon: demoResidenceIcon,
  },
  {
    id: 'demoOccupationIcon',
    demoName: 'Occupation',
    selectedIcon: demoOccupationIcon,
  },
];

class DemographicTripleComparisionDetail extends Component {

  getImageIcon = imageKey => {
    const imageComponent = _.find(iconComponents, { demoName: imageKey });
    if (imageComponent !== undefined) {
      return imageComponent.selectedIcon;
    }
    return undefined;
  }

  renderDeepDiveSlider = value => {
    const { personaIndex, demoDetail, displayDeepDiveSlider, selectedTab } = this.props;

    const deepDivePersonaObject = {
      personaIndex,
      category: demoDetail.name,
      section: 'Demographics',
      selectedTab,
    };
    displayDeepDiveSlider(value, deepDivePersonaObject);
  }

  render() {
    return (
      <div>
        {this.props.demoDetail !== undefined && (
          <div className="demographic-detail-comparision-grid">
            <div
              className="demographic-comparision-float"
              onClick={() => { this.renderDeepDiveSlider(true); }}
            >
              <div className="demographic-float">
                <div
                  className="demographic-comparision-image-border demographic-float"
                  id="demographicFloat"
                >
                  {this.getImageIcon(this.props.demoDetail.name) ===
                    undefined && <div className="imageblock" />}
                  {this.getImageIcon(this.props.demoDetail.name) !==
                    undefined && (
                    <img
                      className="i360-demo-comparision-img"
                      src={this.getImageIcon(this.props.demoDetail.name)}
                      alt={this.props.demoDetail.name}
                    />
                  )}
                  <div className="demo-comparision-icon-labels">
                    {this.props.demoDetail.name}
                  </div>
                </div>
              </div>
              <div className="div-overflow">
                <div className="demographic-float">
                  <div
                    className="demo-triple-comparision-data demo-triple-persona-label"
                    title={this.props.demoDetail.data !== undefined
                    ? this.props.demoDetail.data.label
                    : 'N/A'}
                  >
                    {this.props.demoDetail.data !== undefined
                      ? this.props.demoDetail.data.label
                      : 'N/A'}
                  </div>
                  <div
                    className="demo-triple-comparision-metrics"
                    id="demoTripleIndex"
                  >
                    INDEX:&nbsp;&nbsp;
                    {this.props.demoDetail.data !== undefined
                      ? this.props.demoDetail.data.value.index
                      : 'N/A'}{' '}
                    | REACH:&nbsp;&nbsp;
                    {this.props.demoDetail.data !== undefined
                      ? this.props.demoDetail.data.value.pct
                      : 'N/A'}{' '}
                  </div>
                </div>
              </div>
              {/* <div className="demo-triple-comparision-metrics" id="demoTripleIndex">
              INDEX:&nbsp;&nbsp;{this.props.demoDetail.data.value.index} |
              REACH:&nbsp;&nbsp;{this.props.demoDetail.data.value.pct}
              </div> */}
            </div>
          </div>
        )}
      </div>
    );
  }

}

DemographicTripleComparisionDetail.propTypes = {
  displayDeepDiveSlider: PropTypes.func,
  personaIndex: PropTypes.number,
  demoDetail: PropTypes.shape({
    name: PropTypes.string,
    data: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.shape({
        pct: PropTypes.string,
        index: PropTypes.number,
      })
    })
  }),
  selectedTab: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  const displayDeepDiveSlider = (value, deepDivePersonaObject) => {
    dispatch(insight360Actions.showDeepDivePopup(value, deepDivePersonaObject));
  };
  return {
    displayDeepDiveSlider,
  };
}

export default connect(
  null,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(DemographicTripleComparisionDetail);
